import { render, staticRenderFns } from "./select-city.vue?vue&type=template&id=005e9add"
import script from "./select-city.vue?vue&type=script&lang=js"
export * from "./select-city.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports